<template>
  <section class="hero hero-video">
    <video
      class="hero-bg"
      src="https://lunikhub.ams3.cdn.digitaloceanspaces.com/hybrid-island-race/videos/hybrid-test-feb2026.mp4"
      autoplay
      muted
      loop
      playsinline
      preload="auto"
    ></video>
    <div class="hero-tint"></div>
    <div class="hero-orange-wash"></div>
    <div class="pattern"></div>
    <div class="wrap">
      <div class="meta-strip">
        <TagPill variant="light">MENORCA</TagPill>
        <TagPill variant="light">03 OCTUBRE 2026</TagPill>
        <TagPill variant="light">PLAÇA DES BORN · CIUTADELLA</TagPill>
      </div>
      <h1 class="mark mark-logo">
        <img
            src="/assets/logos/HYBRID-ISLAND-RACE-MENORCA-LOGO-BLANCO.svg"
            alt="Hybrid Island Race · Menorca"
        />
      </h1>
      <div class="hero-tagline">
        La primera carrera híbrida de Menorca.<br />
        <strong>10 pruebas. 750 m entre cada una. En parejas.</strong>
      </div>
      <div class="actions">
        <a class="btn btn-primary btn-lg btn-hard" :href="REGISTRATION_URL" target="_blank" rel="noopener">
          Inscríbete · desde 50 €
          <ArrowRight :size="18" />
        </a>
        <a class="btn btn-outline-light btn-lg" href="#pruebas">Ver pruebas</a>
      </div>
      <div class="stat-strip">
        <div>
          <div class="num">10</div>
          <div class="lbl">Pruebas</div>
        </div>
        <div>
          <div class="num">300</div>
          <div class="lbl">Parejas</div>
        </div>
        <div>
          <div class="num">6</div>
          <div class="lbl">Categorías</div>
        </div>
        <div>
          <div class="num">03·10</div>
          <div class="lbl">Día de carrera</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ArrowRight } from 'lucide-vue-next'
import TagPill from './ui/TagPill.vue'
import { REGISTRATION_URL } from '@/registration'
</script>
